export interface OddsButton {
    tip?: string;
    rate?: number;
    message?: string;
    locked?: boolean;
    empty?: boolean;
    noData?: boolean;
    active?: boolean;
    status?: string;
    notAvailable?: boolean;
    selected?: boolean;
    vertical?: boolean;
    tipHidden?: boolean;
    betRatio?: number;
    showBetRatio?: boolean;
    openEventOnClick?: boolean;
    betRatioHighest?: boolean;
}

export enum RateEnum {
    LOWER = "lower",
    EQUAL = "equal",
    HIGHER = "higher",
}
